export const DOCUMENTATION_URLS = {
  GU_DATAGRID_V3: 'https://gridunity.atlassian.net/wiki/spaces/GRID/pages/3836084245/GuDatagrid+Version+3+Migration+Guide',
}
